export const onboardingWizardKeys = {
  all: ['onboarding-wizard'] as const,
  info: (): readonly string[] => [...onboardingWizardKeys.all, 'info'] as const,
};
